<template>
  <f7-fab position="right-bottom" color="secondary">
    <f7-icon ios="f7:plus" md="material:add"></f7-icon>
    <f7-icon ios="f7:xmark" md="material:close"></f7-icon>
    <f7-fab-buttons position="top">
      <f7-fab-button
        label="Rezervovať si parkovanie"
        @click="f7.popup.open('.parking-reservation-form')"
        fab-close
        ><f7-icon ios="f7:calendar" md="material:calendar_month"></f7-icon
      ></f7-fab-button>
      <f7-fab-button
        label="Pridať vozidlo"
        @click="f7.popup.open('.parking-vehicle-form')"
        fab-close
        ><f7-icon ios="f7:car_fill" md="material:directions_car"></f7-icon
      ></f7-fab-button>
    </f7-fab-buttons>
  </f7-fab>
</template>

<script setup lang="ts">
import { f7 } from 'framework7-vue'
</script>
